import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AddMapping from "../AddMapping";
import UpdateMapping from "../UpdateMapping";
import DeleteMapping from "../DeleteMapping";

import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  SquareButton,
  CircularProgress,
  NotFound,
  FlexRow,
  FlexColumn,
  ButtonGroup,
  Bold,
} from "../../../../Styles";
import {
  Mappings,
  Mapping,
  MappingTitle,
  MappingDetails,
  Product,
  Name,
  ItemID,
  MappingDetailsColumn,
  ItemDetails,
} from "./styles";
import { MappingIcon, MappedIcon } from "../../../../Styles";

import { fetchDentiraMapping } from "../../../../../actions/inventoryActionsV2";
import MappingFormV2 from "../MappingFormV2";

const MappingList = ({ item, refresh, ...props }) => {
  const { supplier_product_id: itemId, name: itemName } = item || {};
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mappings, setMappings] = useState([]);

  const fetchDentiraMapping = async () => {
    setLoading(true);

    const fetchedDentiraMapping =
      (await props.fetchDentiraMapping(itemId)) || [];

    if (fetchedDentiraMapping?.length) {
      setMappings(fetchedDentiraMapping);
    } else {
      setMappings([
        {
          lab_products: [
            {
              item_id: itemId,
              name: itemName,
            },
          ],
          dentira_products: [],
        },
      ]);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (open && itemId) {
      fetchDentiraMapping();
    }
  }, [open]);

  return (
    <>
      <SquareButton primary outline onClick={(e) => setOpen(true)}>
        <MappingIcon />
      </SquareButton>

      {open && (
        <MappingFormV2
          open={open}
          // item={{ itemId, itemName }}
          // onSubmit={() => {
          // if (refresh) {
          // 	refresh();
          // }
          // }}
          onClose={() => {
            setOpen(false);
            if (refresh) {
              refresh();
            }
          }}
          mappingsPropData={mappings}
        />
      )}

      {/* DRAWER IS V1 VERSION, NOT REQUIRED IN V2 changes */}
      {/* <Drawer
				open={open}
				anchor='right'
				onClose={(e) => {
					setOpen(false);
					if (refresh) {
						refresh();
					}
				}}
			>
				<DrawerHeader>
					Dentira Mapping
					<ButtonGroup alignRight>
						<AddMapping
							item={item}
							refresh={() => {
								fetchDentiraMapping();
							}}
						/>
					</ButtonGroup>
				</DrawerHeader>

				<DrawerBody>
					{loading ? (
						<CircularProgress showSpinner={loading} />
					) : (
						<>
							<FlexRow>
								<ItemDetails>
									<ItemID>
										<Bold>Item Id</Bold>: {itemId}
									</ItemID>

									<Name>
										<Bold>Item Name</Bold>: {itemName}
									</Name>
								</ItemDetails>
							</FlexRow>

							<FlexRow>
								{mappings.length ? (
									<Mappings>
										{mappings.map((mapping, index) => (
											<FlexRow>
												<Mapping>
													<MappingTitle>
														{`Mapping ${index + 1}`}

														<ButtonGroup alignRight>
															<UpdateMapping
																item={item}
																mapping={mapping}
																refresh={() => {
																	fetchDentiraMapping();
																}}
															/>

															<DeleteMapping
																item={item}
																mapping={mapping}
																refresh={() => {
																	fetchDentiraMapping();
																}}
															/>
														</ButtonGroup>
													</MappingTitle>

													<MappingDetails>
														<MappingDetailsColumn>
															{(mapping?.lab_products || []).map(({ item_id, name }) => (
																<FlexRow>
																	<Product>
																		<ItemID>{item_id}</ItemID>
																		<Name>{name}</Name>
																	</Product>
																</FlexRow>
															))}
														</MappingDetailsColumn>

														<MappedIcon />

														<MappingDetailsColumn>
															{(mapping?.dentira_products || []).map(({ item_id, name }) => (
																<Product>
																	<FlexColumn>
																		<ItemID>{item_id}</ItemID>
																		<Name>{name}</Name>
																	</FlexColumn>
																</Product>
															))}
														</MappingDetailsColumn>
													</MappingDetails>
												</Mapping>
											</FlexRow>
										))}
									</Mappings>
								) : (
									<FlexColumn>
										<NotFound lines={['No mappings found']} />
									</FlexColumn>
								)}
							</FlexRow>
						</>
					)}
				</DrawerBody>
			</Drawer> */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatch = { fetchDentiraMapping };

export default withRouter(connect(mapStateToProps, mapDispatch)(MappingList));
